const initialState = {
  appliedRoleList: {},
  appliedRoleMetrics: {},
  viewRoleData: {},
  currentAssessment: {
    responses: {}
  }
}
export default (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_ASSESSMENT_RESPONSE':
      return {
        ...state,
        currentAssessment: {
          ...state.currentAssessment,
          responses: {
            ...state.currentAssessment.responses,
            [action.payload.questionId]: action.payload.answer
          }
        }
      }
    case 'SET_APPLIED_ROLE_LIST':
      return {
        ...state,
        appliedRoleList: action.data,
      }
    case 'SET_APPLIED_ROLE_METRICS':
      return {
        ...state,
        appliedRoleMetrics: action.data,
      }
    case 'SET_VIEW_ROLE_DATA':
      return {
        ...state,
        viewRoleData: action.data,
      }
    case 'SET_NEW_ROLE_COUNT':
      return {
          ...state,
          newRoleCount: action.data,
      }  
    default:
      return state
  }
}